import React from "react";
import { useTranslation } from "react-i18next";
import "./ContactHero.css";

/**
 * Contact — Section 01 / Hero premium
 * Textes FR/EN locaux afin de préserver les traductions déjà validées.
 * Aucun changement du formulaire ou de la fonction sendContactEmail.
 */
const CONTENT = {
  fr: {
    eyebrow: "CONTACT · UNITECH ENGINEERING",
    titleStart: "Parlons de",
    titleAccent: "votre projet.",
    description:
      "Vous souhaitez découvrir OPENlift, obtenir des informations sur la Téléalarme ISS ou échanger sur un besoin spécifique ? Expliquez-nous votre demande, nous vous orienterons vers le bon interlocuteur.",
    action: "Choisir ma demande",
    reassurance: "Un échange clair commence ici."
  },
  en: {
    eyebrow: "CONTACT · UNITECH ENGINEERING",
    titleStart: "Let's talk about",
    titleAccent: "your project.",
    description:
      "Looking to discover OPENlift, find out more about ISS emergency communication, or discuss a specific requirement? Tell us what you need and we will direct your enquiry to the right person.",
    action: "Choose your enquiry",
    reassurance: "A clear conversation starts here."
  }
};

export default function ContactHero() {
  const { i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "fr")
    .split("-")[0]
    .toLowerCase();
  const content = CONTENT[language] || CONTENT.fr;

  return (
    <header className="contact-hero">
      <div className="contact-hero__graphic" aria-hidden="true">
        <span className="contact-hero__arc contact-hero__arc--one" />
        <span className="contact-hero__arc contact-hero__arc--two" />
      </div>
      <div className="contact-hero__inner">
        <p className="contact-hero__eyebrow">{content.eyebrow}</p>
        <h1 className="contact-hero__title" id="contact-title">
          {content.titleStart} <span>{content.titleAccent}</span>
        </h1>
        <p className="contact-hero__lead">{content.description}</p>
        <div className="contact-hero__actions">
          <a className="contact-hero__link" href="#contact-besoin">
            {content.action} <span aria-hidden="true">→</span>
          </a>
          <span className="contact-hero__hint">{content.reassurance}</span>
        </div>
      </div>
    </header>
  );
}
